import { camelCase } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, permissionPresets, states } from '@/utils'

import button from '@/components/button'
import FormTitle from '@/components/misc/FormTitle'

function renderDialog(h, options) {
  let slotTitleCreate = h(
    FormTitle,
    {
      class: 'pt-2 px-2',
      props: {
        value: this.restData[options.name].create.data,
        errors: this.restData[options.name].create.errors
      },
      on: {
        input: event => {
          this.restData[options.name].create.data = event
        },
        submit: () => {
          this.createData()
        },
        validation: event => {
          this.titleIsValid = event
        }
      }
    }
  )
  if (this.$scopedSlots.titleCreate) {
    slotTitleCreate = this.$scopedSlots.titleCreate({ data: this.restData[options.name].create.data })
  } else if (this.$slots.titleCreate) {
    slotTitleCreate = this.$slots.titleCreate
  }

  let maxWidth
  if (this.viewport.breakpoint.mdUp) {
    maxWidth = this.maxWidth
  }

  return h(
    components.dialog,
    {
      props: {
        value: this.showDialog,
        maxWidth,
        title: this.title
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      h(
        `${camelCase(`${options.name}-form`)}`,
        {
          props: {
            value: this.restData[options.name].create.data,
            errors: this.restData[options.name].create.errors,
            isNew: true
          },
          on: {
            input: event => {
              this.restData[options.name].create.data = event
            },
            submit: () => {
              this.createData()
            },
            validation: event => {
              this.restData[options.name].create.isValid = event
            }
          }
        }
      ),

      h('div', { slot: 'header' }, [ slotTitleCreate ]),

      h(
        'div',
        {
          class: 'fjcfe facfe grid-gap--8 pa-2',
          slot: 'footer'
        },
        [
          h(
            button,
            {
              props: {
                mode: buttonModes.flat,
                label: this.getTranslate('misc.buttons.cancel'),
                disabled: this.restData[options.name].create.state === states.loading
              },
              on: {
                click: () => {
                  this.showDialog = false
                }
              }
            }
          ),

          h(
            button,
            {
              props: {
                label: this.getTranslate('misc.buttons.create'),
                loading: this.restData[options.name].create.state === states.loading,
                disabled: !this.createDataIsValid,
                color: Colors.primary
              },
              on: {
                click: () => {
                  this.createData()
                }
              }
            }
          )
        ]
      )
    ]
  )
}

export default function(h, options) {
  if (!options.excludeCreate) {
    if (this.checkPermissions(`advanced.${options.name}.create`, permissionPresets.meUp)) {
      switch (this.type) {
        case 'button': {
          return h(
            button,
            {
              props: {
                icon: icons.add,
                mode: buttonModes.flat,
                color: Colors.secondary
              },
              on: {
                click: () => {
                  this.showDialog = true
                }
              },
              scopedSlots: {
                dialog: () => {
                  return renderDialog.call(this, h, options)
                }
              }
            }
          )
        }

        case 'list-item':
        default: {
          return h(
            components['list-item'],
            {
              props: {
                label: this.getTranslate('misc.buttons.create'),
                color: Colors.secondary,
                dense: true,
                rounded: true
              },
              on: {
                click: () => {
                  this.showDialog = true
                }
              },
              scopedSlots: {
                dialog: () => {
                  return renderDialog.call(this, h, options)
                }
              }
            }
          )
        }
      }
    }
  }
}
